module.exports = __webpack_public_path__ + "images/review_star_light_79bcc8c80e8fc8a0a85f0c370c9ae6c8.png";